import React from 'react';
import {POSITION, ALIGN, COLOR, Icon, Text, View} from '@lookiero/aurora';
import {Pressable} from 'react-native-gesture-handler';

import {style} from './SubNavigation.style';
import {ViewStyle} from 'react-native';

export type SubNavigationProps = {
  barStyle?: ViewStyle;
  children?: React.ReactNode;
  title?: string;
  onBack?: () => void;
};

// we use react-native-gesture-handler Pressable as a workaround for this issue
// https://github.com/expo/expo/issues/29489
const BackButton: React.FC<{onPress: () => void}> = ({onPress}) => (
  <Pressable style={style.backButton} onPress={onPress}>
    <Icon name="arrow_left" testID="navbar-back-button" nativeID="HeaderBack" />
  </Pressable>
);

const Title: React.FC<{children: string}> = ({children}) => (
  <Text action align={ALIGN.CENTER} color={COLOR.TEXT} position={POSITION.ABSOLUTE} style={style.title}>
    {children}
  </Text>
);

export const SubNavigation: React.FC<SubNavigationProps> = ({onBack, title, children, barStyle}) => {
  return (
    <View style={[style.container, barStyle]}>
      {onBack && <BackButton onPress={onBack} />}
      {title ? <Title>{title}</Title> : children}
    </View>
  );
};
